<template>
       
    <div class="our-call-center-view" data-sectionThemeDark="true">
        <return-menu  />
        <!-- <responsive-burger-menu   v-bind:MenuItems="MenuItems" /> -->
        <!-- home page view , each <section> must be a layout component -->
        <landing-intro-secondary v-bind:LandingIntroData="LandingIntroData" />    
        
        <section class="executive-summary section" data-sectionThemeDark="false">
            
            <div class="summary-container">
                <h2 class="section-heading --tert">Our innovative call centre support</h2>
                <p class="content-text">
                    Global Choices invests heavily in technology and as such owns and manages our own 24 hour contact centre at our head office in Johannesburg. Our 60 seater contact centre using the latest technology provides 24hour personal 1on1 call taking and case management services for any client requirement, be it an emergency, concierge, redemption or travel request. Our highly trained case management team records each interaction into our case management platform as well as all calls being recorded. 
                </p>
                <div >
                    {{randomTestimonial()}}
                </div>
            </div>
            <div class="scroll-indicator-container">
                    
            </div>
        </section>  

        <OurStars v-bind:OurStarsList="OurStarsList"/>
        <Testimonials />
        <contact-us v-bind="ContactUsData" />
        <FooterLayout />
    </div>
</template>

<script>
import ReturnMenu from '@/components/ui/ReturnMenu'
// import ResponsiveBurgerMenu from '@/components/ui/ResponsiveBurgerMenu'
import LandingIntroSecondary from '@/components/layout/LandingIntroSecondary'
import OurStars from '@/components/layout/OurStars'
import Testimonials from '@/components/layout/Testimonials'
import ContactUs from '@/components/layout/ContactUs'
import FooterLayout from '@/components/layout/Footer'
import OurStarsJson from "@/assets/OurStars.json";

export default {
    
   components: { ReturnMenu,LandingIntroSecondary,OurStars,Testimonials,ContactUs,FooterLayout},
   
   data(){

    

        return {
            LandingIntroData:{
                NameLocation:'#Home',
                BackgroundClass:'--call-center',
                HeadingText:'“I was so impressed with the staff and their excellent service! They kept me updated all the time and even called to see if the problem was sorted. Keep up the good service delivery!”',
                Speaker:null,
                Btn:'#keepingYouSafe',
                BtnState:false,
                ShowVideo:false
            },
            OurStarsList: OurStarsJson,
            // OurStarsList: 
            // [
            //     {
            //         id:0,
            //         image:"aaron-serumula.png",
            //         name :"Aaron Serumula",
            //         active:true,
            //         sortOrder:1
            //     },
            //     {
            //         id:1,
            //         image:"aviwe-thwalo.png",
            //         name :"Aviwe Thwalo",
            //         active:true,
            //         sortOrder:2
            //     },
            //     {
            //         id:2,
            //         image:"happy-mangali.png",
            //         name :"Happy Mangali",
            //         active:true,
            //         sortOrder:3
            //     },
            //     {
            //         id:3,
            //         image:"jardine-albertyn.png",
            //         name :"Jardine Albertyn",
            //         active:true,
            //         sortOrder:4
            //     },
            //     {
            //         id:4,
            //         image:"lamont-mothlabani.png",
            //         name :"Lamont Motlhabani",
            //         active:true,
            //         sortOrder:5
            //     },
            //     {
            //         id:5,
            //         image:"mary-ratlhogo.png",
            //         name :"Mary Ratlhogo",
            //         active:true,
            //         sortOrder:6
            //     },
            //     {
            //         id:6,
            //         image:"mpho-mmekwa.png",
            //         name :"Mpho Mmekwa",
            //         active:true,
            //         sortOrder:7
            //     },
            //     {
            //         id:7,
            //         image:"naeem-griffin.png",
            //         name :"Naeem Griffin",
            //         active:false,
            //         sortOrder:8
            //     },
            //     {
            //         id:8,
            //         image:"miceala-meintjies.png",
            //         name :"Miceala Meintjies",
            //         active:false,
            //         sortOrder:9
            //     },
            //     {
            //         id:9,
            //         image:"mishack-kekana.png",
            //         name :"Mishack Kekana",
            //         active:false,
            //         sortOrder:10
            //     },
            //     {
            //         id:10,
            //         image:"sylvester-rugan.png",
            //         name :"Sylvester Rugan",
            //         active:true,
            //         sortOrder:11
            //     },
            //     {
            //         id:14,
            //         image:"jatine-rowjee.png",
            //         name :"Jatine Rowjee",
            //         active:true,
            //         sortOrder:15
            //     },
            //     {
            //         id:15,
            //         image:"romano-perumal.png",
            //         name :"Romano Perumal",
            //         active:true,
            //         sortOrder:16
            //     },
            //     {
            //         id:16,
            //         image:"selvan-pandaram.png",
            //         name :"Selvan Pandaram",
            //         active:true,
            //         sortOrder:17
            //     },
            //     {
            //         id:17,
            //         image:"alice-laxa.png",
            //         name :"Alice Laxa",
            //         active:false,
            //         sortOrder:18
            //     },
            //     {
            //         id:18,
            //         image:"wandile-makhubu.png",
            //         name :"Wandile Makhubu",
            //         active:true,
            //         sortOrder:19
            //     },
            //     {
            //         id:19,
            //         image:"noludumo-quntana.png",
            //         name :"Noludumo Quntana",
            //         active:true,
            //         sortOrder:20
            //     },
            //     {
            //         id:20,
            //         image:"noel-khumalo.png",
            //         name :"Noel Khumalo",
            //         active:true,
            //         sortOrder:21
            //     },
            //     {
            //         id:21,
            //         image:"monique-carstens.png",
            //         name :"Monique Carstens",
            //         active:false,
            //         sortOrder:22
            //     },
            //     {
            //         id:22,
            //         image:"leroy-matthews.png",
            //         name :"Leroy Matthews",
            //         active:true,
            //         sortOrder:23
            //     },
            //     {
            //         id:23,
            //         image:"leilanie-higgins.png",
            //         name :"Leilanie Higgins",
            //         active:false,
            //         sortOrder:24
            //     },
            //     {
            //         id:24,
            //         image:"laurette-fouche.png",
            //         name :"Laurette Fouche",
            //         active:false,
            //         sortOrder:25
            //     },
            //     {
            //         id:26,
            //         image:"karabo-khunou.png",
            //         name :"Karabo Khunou",
            //         active:true,
            //         sortOrder:27
            //     },
            //     {
            //         id:27,
            //         image:"john-mathidi.png",
            //         name :"John Mathidi",
            //         active:false,
            //         sortOrder:28
            //     },
            //     {
            //         id:28,
            //         image:"helen-africa.png",
            //         name :"Helen Africa",
            //         active:false,
            //         sortOrder:29
            //     },
            //     {
            //         id:29,
            //         image:"eugene-baleni.png",
            //         name :"Eugene Baleni",
            //         active:true,
            //         sortOrder:30
            //     },
            //     {
            //         id:30,
            //         image:"claudia-van-zyl.png",
            //         name :"Claudia van Zyl",
            //         active:true,
            //         sortOrder:31
            //     },
            //     {
            //         id:31,
            //         image:"brian-skosana.png",
            //         name :"Brian Skosana",
            //         active:false,
            //         sortOrder:32
            //     },
            //     {
            //         id:32,
            //         image:"mzwandile-ndalase.png",
            //         name :"Mzwandile Ndalase",
            //         active:true,
            //         sortOrder:33
            //     },
            //     {
            //         id:33,
            //         image:"levy-mkokga.png",
            //         name :"Levy Mkokga",
            //         active:true,
            //         sortOrder:34
            //     },
            //     {
            //         id:34,
            //         image:"aaqilah-isaacs.png",
            //         name :"Aaqilah Isaacs",
            //         active:false,
            //         sortOrder:35
            //     },
            //     {
            //         id:35,
            //         image:"muzovukile-nkabinde.png",
            //         name :"Muzovukile Nkabinde",
            //         active:true,
            //         sortOrder:36
            //     },
            //     {
            //         id:36,
            //         image:"thulile-zwane.png",
            //         name :"Thulile Zwane",
            //         active:false,
            //         sortOrder:37
            //     },
            //     {
            //         id:38,
            //         image:"dipuo-qholosha.png",
            //         name :"Dipuo Qholosha",
            //         active:true,
            //         sortOrder:39
            //     },
            //     {
            //         id:40,
            //         image:"basiame-phillips.png",
            //         name :"Basiame Phillips",
            //         active:true,
            //         sortOrder:41
            //     },
            //     {
            //         id:42,
            //         image:"cleoreez_ricketts.png",
            //         name:"Cleoreez Ricketts",
            //         active:true,
            //         sortOrder:43
            //     },
            //     {
            //         id:43,
            //         image:"elvina-rowjee.png",
            //         name :"Elvina Rowjee",
            //         active:true,
            //         sortOrder:44
            //     },
            //     {
            //         id:44,
            //         image:"george-ngobeni.png",
            //         name :"George Ngobeni",
            //         active:true,
            //         sortOrder:45
            //     },
            //     {
            //         id:45,
            //         image:"john-mathidi-2.png",
            //         name :"John Mathidi",
            //         active:true,
            //         sortOrder:46
            //     },
            //     {
            //         id:46,
            //         image:"loyiso-nhlazane.png",
            //         name :"Loyiso Nhlazane",
            //         active:true,
            //         sortOrder:47
            //     },
            //     {
            //         id:47,
            //         image:"luvuyo-ntsime.png",
            //         name :"Luvuyo Ntsime",
            //         active:true,
            //         sortOrder:48
            //     },
            //     {
            //         id:48,
            //         image:"dorne_rugan.png",
            //         name:"Dorne Rugan",
            //         active:true,
            //         sortOrder:49
            //     },
            //     {
            //         id:49,
            //         image:"ntanganedzeni-magidi.png",
            //         name :"Ntanganedzeni Magidi",
            //         active:true,
            //         sortOrder:50
            //     },
            //     {
            //         id:50,
            //         image:"stephen-masiangoako.png",
            //         name :"Stephen Masiangoako",
            //         active:true,
            //         sortOrder:51
            //     },
            //     {
            //         id: 51,
            //         image: "brigieta_blignaut.png",
            //         name: "Brigieta Blignaut",
            //         active: true,
            //         sortOrder: 51
            //     },
            //     {
            //         id: 53,
            //         image: "sammjo_ogle.png",
            //         name: "Sammjo Ogle",
            //         active: true,
            //         sortOrder: 53
            //     },
            //     {
            //         id: 54,
            //         image: "mogale_molokwoane.png",
            //         name: "Mogale Molokwoane",
            //         active: true,
            //         sortOrder: 54
            //     },
            //     {
            //         id: 55,
            //         image: "baleseng_mkandabili.png",
            //         name: "Baleseng Mkandabili",
            //         active: true,
            //         sortOrder: 55
            //     },
            //     {
            //         id: 56,
            //         image: "godfrey_masindi.png",
            //         name: "Godfrey Masindi",
            //         active: true,
            //         sortOrder: 56
            //     },
            //     {
            //         id: 57,
            //         image: "ziyaad_hoosen.png",
            //         name: "Ziyaad Hoosen",
            //         active: true,
            //         sortOrder: 57
            //     }
            // ],
            TestimonialList:[
                {
                    id:1,
                    testimonial:'"Our client has complimented on the speedy service he received, thank you for continuously going the extra mile to ensure our client’s needs are put above the rest."',
                    speaker:'Agents: Mpho, Sylvester',
                    active:true
                },
                {
                    id:2,
                    testimonial:'"This is the best insurance company to rely on, everyone keep on checking if you have being assisted or not...best experience ever."',
                    speaker:'Agents: Aaron, Bryce',
                    active:true
                },
                {
                    id:3,
                    testimonial:'"I would like to put Aviwe’s name up for being the most caring emergency services agent. I had an accident and when I called in, he picked up. He did the magics, and everything got organised within minutes."',
                    speaker:'Agent: Aviwe',
                    active:true
                },
                {
                    id:4,
                    testimonial:'"I found the lady that I spoke to be very courteous and extremely efficient. The tow truck arrived within half an hour and the driver was courteous and friendly and we arrived home safe and sound. Thanks for the excellent service."',
                    speaker:'Agents: Dipuo',
                    active:true
                },
                {
                    id:5,
                    testimonial:'"Professional and friendly service.  Details were taken and without any delay, the process was started. The best service we have ever received from a road assist insitution! Please convey our deepest gratitude to Romano.  You can be assured that whenever the opportunity arises, we will gladly recommend this insurance."',
                    speaker:'Agent: Romano',
                    active:true
                },
                {
                    id:6,
                    testimonial:'"I was so impressed with the staff and their service ….Excellent ! ….they kept me updated all the time and even called to see if the problem was sorted. Keep up the good service delivery!"',
                    speaker:'Agent: Mzwandile, <br>Romano, Thulile',
                    active:true
                }, 
                {
                    id:9,
                    testimonial:'“The experience was so good! The call centre agent I spoke to was lovely and efficient (Elvina) and then the towing company (Cargo Towing) was here in a flash and had me running in seconds!”',
                    speaker:'Sally Barker',
                    active:true
                },
                {
                    id:10,
                    testimonial:'“Fantastic! Thank you to you and your team for the amazing service with this towing.<br>I appreciate it.”',
                    speaker:'Elanie Hattingh',
                    active:true
                },
                {
                    id:11,
                    testimonial:'“We used Frontline Assist this morning, as one of our company vehicles would not start. It was honestly a pleasurable experience; the consultant Martin was seriously helpful and efficient. I called at 8:30am, gave my policy details and particulars and the tow company was there just after 9:30am. Fantastic service, thanks!”',
                    speaker:'Dayle van Straaten ',
                    active:true
                },
                {
                    id:12,
                    testimonial:'“Thank you for below, it was a pleasure to deal with you.”',
                    speaker:'Agent: Ntanganedzeni',
                    active:true
                },
                {
                    id:13,
                    testimonial:'“I would just like to say thank you for the prompt and very good roadside service I received on Sunday when I had a flat tyre.”',
                    speaker:'Agent: Mpho',
                    active:true
                },
                {
                    id:14,
                    testimonial:'“As mentioned earlier, thank you very much for always assisting me. You are a star and I do not know what I would do without you. Please do not ever leave.”',
                    speaker:'Dante Kruger',
                    active:true
                },
                {
                    id:15,
                    testimonial:'“Thank you so much Elvina, appreciated. Again, your service is fantastic!!!”',
                    speaker:'Luana Ramirez',
                    active:true
                }
            ],
            ContactUsData:[{
                NameLocation:'ContactUs',
                items: ['Client Service', 'Finance', 'Resolutions', 'Procurement', 'Medical Desk']
            }], 
        }
   },


  mounted: function() {
    // Checking if everything works, delete this right after you see that everything works
    console.log(this.OurStarsList);
  },

   methods:{
       
        randomTestimonial : function(){
            // let arr = []
            // arr = this.TestimonialList.filter((TestimonialList) => {
            //     return TestimonialList.active == true
            // })
            let TestimonialText='', TestimonialSpeaker='', TestimonialListLength = this.TestimonialList.length;
            // console.log(arr)
            // let TestimonialText='', TestimonialSpeaker='', TestimonialListLength = this.arr.length;
            
            let RandomNo = Math.floor(Math.random() * (TestimonialListLength - 1 )) + 1;
            
           TestimonialText = this.TestimonialList[RandomNo].testimonial;
           TestimonialSpeaker = this.TestimonialList[RandomNo].speaker;
            
            this.LandingIntroData.HeadingText = TestimonialText;
            this.LandingIntroData.Speaker = TestimonialSpeaker;
             
            
           

            // return this.ClaimFormsList.filter((ClaimFormsList) => {
            //     return ClaimFormsList.providerID.match(this.SelectedInsurer)
            // })
             
        }
        // ,
        // mounted: function(){
        //     this.readJson(require("./public/doc.json"))
        // }
        // ,readJson: function(filePath) {
        //     var request = new XMLHttpRequest();
        //     request.open("GET",filePath, false);
        //     console.log(request)
        //     request.send(null)
        //     var my_JSON_object = JSON.parse(request.responseText);
        //     alert (my_JSON_object.result[0]);
        // }
   } 
}



</script>

<style lang="scss"></style>
